import { render, staticRenderFns } from "./OilTankCertificateStatus.vue?vue&type=template&id=f06bc9ae&"
import script from "./OilTankCertificateStatus.vue?vue&type=script&lang=ts&"
export * from "./OilTankCertificateStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports